import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { Observable, map } from 'rxjs';

import { UserLoginService } from '@routes/user-login/user-login.service';
import { ApplicationService } from '@core/services/application.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authService: MsalService,
    private loginService: UserLoginService,
    private router: Router,
    private appservice: ApplicationService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {

    const isLoggedIn = this.loginService.isLoggedIn();

    const account = this.authService?.instance?.getAllAccounts()?.[0];


    this.appservice.app.userId = account?.homeAccountId ?? '';

    const roles = account?.idTokenClaims?.roles ?? [];
    this.appservice.app.roles = roles;
    this.appservice.setRoles(roles);

    return this.appservice.hasRole('supervisor').pipe(
      map(isSupervisor => {
        if (isLoggedIn && isSupervisor) {
          return true;
        } else if (isLoggedIn && !isSupervisor) {
          this.router.navigate(['unauthorised']);
          return false;
        } else {
          return false;
        }
      })
    );
  }
}
